import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001';
const HEARTBEAT_SECONDS = 15;

const ROUTE_LABELS = {
  '/dashboard': 'Pano',
  '/satinalma': 'Satınalma',
  '/stok-depo': 'Stok & Depo',
  '/uretim': 'Üretim',
  '/recete-maliyet': 'Reçete & Maliyet',
  '/finans': 'Finans',
  '/muhasebe-logo': 'Muhasebe & Logo',
  '/raporlar-grup': 'Raporlar',
  '/tedarikciler-grup': 'Tedarikçiler',
  '/entegrasyon': 'Entegrasyon',
  '/yonetim': 'Yönetim',
  '/talep/olustur': 'Talep Oluştur',
  '/talep/listesi': 'Talep Listesi',
  '/siparisler': 'Siparişler',
  '/siparis/olustur': 'Sipariş Oluştur',
  '/dogrudan-mal-kabul': 'Doğrudan Mal Kabul',
  '/mal-kabul': 'Mal Kabul',
  '/ihtiyac-listesi': 'İhtiyaç Listesi',
  '/onaylar': 'Bekleyen Onaylar',
  '/stok/durum': 'Stok Durumu',
  '/stok/sayim': 'Stok Sayım',
  '/stok/sayim-gecmis': 'Stok Sayım Geçmişi',
  '/stok/hareketler': 'Stok Hareketleri',
  '/zayi-girisi': 'Zayi Girişi',
  '/birim-donusumleri': 'Birim Dönüşümleri',
  '/stok/abc-analiz': 'ABC Analizi',
  '/stok/excel-sayim-import': 'Excel Sayım Aktarımı',
  '/inventory': 'Envanter',
  '/uretim-kaydi': 'Üretim Kaydı',
  '/ikincil-isleme': 'İkincil İşleme',
  '/satis-analiz': 'Satış Analizi',
  '/urun-satis-raporu': 'Ürün Satış Raporu',
  '/pos-satış': 'POS Satış',
  '/recete/olustur': 'Reçete Oluştur',
  '/recete/duzenle': 'Reçete Düzenle',
  '/maliyet-analiz': 'Maliyet Analizi',
  '/food-cost': 'Food Cost',
  '/fiyat-girisi': 'Fiyat Girişi',
  '/gider-girisi': 'Gider Girişi',
  '/gecici-vergi': 'Geçici Vergi',
  '/stopaj-raporu': 'Stopaj Raporu',
  '/odeme-planı': 'Ödeme Planı',
  '/cari-hesaplar': 'Cari Hesaplar',
  '/faturalandirma': 'Faturalandırma',
  '/sirketler-arasi-satislar': 'Şirketler Arası Satışlar',
  '/satislar/musteriler': 'Müşteriler',
  '/satislar/irsaliyeler': 'Satış İrsaliyeleri',
  '/satislar/irsaliye/yeni': 'Satış İrsaliyesi Oluştur',
  '/satislar/faturalar': 'Satış Faturaları',
  '/satislar/fatura/yeni': 'Satış Faturası Oluştur',
  '/satislar/tahsilatlar': 'Tahsilatlar',
  '/satislar/alacak-takibi': 'Alacak Takibi',
  '/satislar/iadeler': 'Satış İadeleri',
  '/analiz/pnl': 'Kâr / Zarar Analizi',
  '/analiz/satinalma': 'Satınalma Analizi',
  '/analiz/satis': 'Satış Analizi',
  '/analiz/stok-uretim': 'Stok & Üretim Analizi',
  '/analiz/komisyon-detay': 'Komisyon Detayı',
  '/analiz/maliyet-varyans': 'Maliyet Varyans',
  '/analiz/satis-kanal': 'Satış Kanal Analizi',
  '/zayi-raporu': 'Zayi Raporu',
  '/tuketim-raporu': 'Tüketim Raporu',
  '/skt-bozulma': 'SKT / Bozulma',
  '/tedarikciler': 'Tedarikçiler',
  '/fiyat-takip': 'Fiyat Takip',
  '/tedarikci-karnesi': 'Tedarikçi Karnesi',
  '/logo/faturalar': 'Logo Faturalar',
  '/logo/senkronizasyon': 'Logo Senkronizasyon',
  '/entegrasyon/eslestirme': 'Eşleştirme Merkezi',
  '/menu-muhendisligi': 'Menü Mühendisliği',
  '/analiz-sonuclari': 'Analiz Sonuçları',
  '/fiyat-simulasyonu': 'Fiyat Simülasyonu',
  '/ik': 'İnsan Kaynakları',
  '/kullanicilar': 'Kullanıcılar',
  '/master-veriler': 'Master Veriler',
  '/veri-duzeltme': 'Veri Düzeltme',
  '/ayarlar': 'Ayarlar',
  '/ayarlar/pos-terminalleri': 'POS Terminalleri',
  '/ayarlar/fizibilite-tanimlar': 'Fizibilite Tanımları',
  '/ayarlar/stok-referans-butunlugu': 'Stok Referans Bütünlüğü',
  '/ayarlar/stok-referans-butunlugu/detay': 'Stok Referans Bütünlüğü Detayı',
  '/yedekleme': 'Yedekleme',
  '/log-kayitlari': 'Log Kayıtları',
  '/yonetim-paneli': 'Yönetim Paneli',
  '/kasa-kapanis': 'Kasa Kapanış',
  '/kasa-defter': 'Kasa Defteri',
};

const getPageName = (pathname) => {
  if (ROUTE_LABELS[pathname]) return ROUTE_LABELS[pathname];
  if (/^\/siparis\/detay\/[^/]+$/.test(pathname)) return 'Sipariş Detayı';
  if (/^\/mal-kabul\/[^/]+$/.test(pathname)) return 'Mal Kabul Detayı';
  if (/^\/grn\/detay\/[^/]+$/.test(pathname)) return 'Mal Kabul Detayı';
  if (/^\/analiz\/tedarikci\/[^/]+$/.test(pathname)) return 'Tedarikçi Analizi';
  return pathname;
};

const getToken = () => localStorage.getItem('access_token');

const authHeaders = () => {
  const token = getToken();
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

const PageUsageTracker = () => {
  const location = useLocation();
  const logIdRef = useRef(null);
  const intervalRef = useRef(null);
  const sessionIdRef = useRef(`${Date.now()}-${Math.random().toString(36).slice(2)}`);

  const stopHeartbeat = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const sendHeartbeat = async () => {
    if (!logIdRef.current) return;
    if (document.visibilityState !== 'visible') return;
    if (!document.hasFocus()) return;

    try {
      await fetch(`${API_URL}/api/page-usage/heartbeat`, {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify({
          log_id: logIdRef.current,
          active_seconds: HEARTBEAT_SECONDS,
        }),
      });
    } catch (_) {
      // Kullanım takibi ana ERP akışını bozmamalı.
    }
  };

  const closeCurrent = async () => {
    stopHeartbeat();
    const logId = logIdRef.current;
    logIdRef.current = null;
    if (!logId) return;

    try {
      await fetch(`${API_URL}/api/page-usage/leave`, {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify({ log_id: logId }),
        keepalive: true,
      });
    } catch (_) {
      // Kullanım takibi ana ERP akışını bozmamalı.
    }
  };

  const startCurrent = async (pathname) => {
    if (!getToken()) return;

    try {
      const response = await fetch(`${API_URL}/api/page-usage/start`, {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify({
          page_path: pathname,
          page_name: getPageName(pathname),
          session_id: sessionIdRef.current,
        }),
      });

      if (!response.ok) return;
      const data = await response.json();
      logIdRef.current = data.log_id;

      stopHeartbeat();
      intervalRef.current = setInterval(sendHeartbeat, HEARTBEAT_SECONDS * 1000);
    } catch (_) {
      // Kullanım takibi ana ERP akışını bozmamalı.
    }
  };

  useEffect(() => {
    let cancelled = false;

    const switchPage = async () => {
      await closeCurrent();
      if (!cancelled) await startCurrent(location.pathname);
    };

    switchPage();

    return () => {
      cancelled = true;
      closeCurrent();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    const onPageHide = () => closeCurrent();
    window.addEventListener('pagehide', onPageHide);

    return () => {
      window.removeEventListener('pagehide', onPageHide);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default PageUsageTracker;
